<template>
  <div class="form-group row">
    <label for="apiKey" class="col-md-3 text-left">API Key:</label>
    <div class="col-md-10">
      <input
        class="form-control"
        :value="getApiKey"
        type="text"
        readonly
      />
    </div>
    <div class="col-md-2">
      <button
        @click="() => CopyToClipboard(getApiKey, Toaster)"
        class="smallButton button-3"
      >
        Copy API Key
      </button>
    </div>
  </div>
</template>

<script>
import "mosha-vue-toastify/dist/style.css";
import { mapGetters } from "vuex";
import { Toaster, CopyToClipboard } from "../../../../customFunctions/Utils.js";
export default {
  name: "show-apikey-container",
  computed: {
    ...mapGetters(["getApiKey"]),
  },
  setup() {
    return { CopyToClipboard, Toaster };
  },
};
</script>
